(() => {
  'use strict';
  if (window.retroPromotionsLoaded) return;
  window.retroPromotionsLoaded = true;

  const VISIT_MS = 60 * 60 * 1000;
  const CART_MS = 10 * 60 * 1000;
  // Personal visit timers, independent of prices, offers and inventory.
  // Keep deadlines in this document: an old browser deadline cannot strand a returning visitor at zero.
  let visitEnd = Date.now() + VISIT_MS;
  let cartEnd = null;
  let cartActive = false;
  let openDrawers = new Set();
  let panels = [];
  const bar = document.querySelector('[data-re-sale]');
  const pad = value => String(value).padStart(2, '0');
  const setText = (element, value) => {
    if (element && element.textContent !== value) element.textContent = value;
  };

  function tick() {
    const now = Date.now();
    // Renew expired periods, including after a suspended tab or a clock adjustment.
    if (visitEnd <= now || visitEnd > now + VISIT_MS) visitEnd = now + VISIT_MS;
    const visitLeft = Math.ceil((visitEnd - now) / 1000);
    if (bar) {
      bar.hidden = false;
      setText(bar.querySelector('[data-re-hours]'), pad(Math.floor(visitLeft / 3600)));
      setText(bar.querySelector('[data-re-minutes]'), pad(Math.floor(visitLeft % 3600 / 60)));
      setText(bar.querySelector('[data-re-seconds]'), pad(visitLeft % 60));
    }
    if (cartActive && (!cartEnd || cartEnd <= now || cartEnd > now + CART_MS)) cartEnd = now + CART_MS;
    const left = cartActive ? Math.ceil((cartEnd - now) / 1000) : CART_MS / 1000;
    panels.forEach(panel => {
      setText(panel.querySelector('[data-re-cart-clock]'), `${pad(Math.floor(left / 60))}:${pad(left % 60)}`);
      const progress = panel.querySelector('[data-re-cart-progress]');
      if (progress) progress.style.transform = `scaleX(${left / (CART_MS / 1000)})`;
    });
  }

  function scan() {
    panels = [...document.querySelectorAll('[data-re-cart-promo]')];
    const drawers = new Set();
    let hasCartPage = false;
    panels.forEach(panel => {
      const drawer = panel.closest('cart-drawer');
      if (!drawer) {
        const cartItems = panel.closest('cart-items');
        if (!cartItems || !cartItems.classList.contains('is-empty')) hasCartPage = true;
      }
      else if (drawer.classList.contains('active') && !drawer.classList.contains('is-empty')) drawers.add(drawer);
    });
    const active = hasCartPage || drawers.size > 0;
    const opened = [...drawers].some(drawer => !openDrawers.has(drawer));
    if (active && (!cartActive || opened)) cartEnd = Date.now() + CART_MS;
    if (!active) cartEnd = null;
    cartActive = active;
    openDrawers = drawers;
    tick();
  }

  function restartVisit() {
    visitEnd = Date.now() + VISIT_MS;
    cartEnd = cartActive ? Date.now() + CART_MS : null;
    scan();
  }

  const observer = new MutationObserver(records => {
    // Listen for drawer open/close and replacement sections, never for our own digit updates.
    if (records.some(record => record.type === 'attributes' ||
      [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1))) scan();
  });
  observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
  document.addEventListener('visibilitychange', () => { if (!document.hidden) restartVisit(); });
  window.addEventListener('pageshow', event => { if (event.persisted) restartVisit(); });
  document.addEventListener('shopify:section:load', scan);
  scan();
  setInterval(tick, 1000);
})();
